import { ContentMap } from '../../types';
import { baNaHillsParkContent } from './ba-na-hills-park';
import { catCatVillageContent } from './cat-cat-village';
import { cuChiTunnelsContent } from './cu-chi-tunnels';
import { haGiangContent } from './ha-giang';
import { haLongBayContent } from './ha-long-bay';
import { hanoiContent } from './hanoi';
import { hoChiMinhCityContent } from './ho-chi-minh-city';
import { hoiAnContent } from './hoi-an';
import { maiChauContent } from './mai-chau';
import { mekongRiverDeltaContent } from './mekong-river-delta';
import { ninhBinhContent } from './ninh-binh';
import { phongNhaContent } from './phong-nha';
import { phuQuocIslandContent } from './phu-quoc-island';
import { puLuongContent } from './pu-luong';
import { relatedArticlesSlugsMap } from './relatedArticlesSlugsMap';
import { saPaContent } from './sa-pa';

export const vietnamDestinationsContentMap: ContentMap = {
  'phu-quoc-island': phuQuocIslandContent,
  'cu-chi-tunnels': cuChiTunnelsContent,
  'mekong-river-delta': mekongRiverDeltaContent,
  'ho-chi-minh-city': hoChiMinhCityContent,
  'ba-na-hills-park': baNaHillsParkContent,
  'pu-luong': puLuongContent,
  'mai-chau': maiChauContent,
  'cat-cat-village': catCatVillageContent,
  'sa-pa': saPaContent,
  'ha-giang': haGiangContent,
  'ha-long-bay': haLongBayContent,
  hanoi: hanoiContent,
  'ninh-binh': ninhBinhContent,
  'hoi-an': hoiAnContent,
  'phong-nha': phongNhaContent,
};

export const vietnamDestinationsCardData = [
  {
    title: 'פוקוק',
    description:
      'אי טרופי מרהיב בוייטנאם עם חופים לבנים, טבע עשיר, אטרקציות מודרניות וכפרים מסורתיים – חופשה חלומית במזרח',
    imageUrl: '/images/vietnam/phu-quoc/phu_quac_preview.jpeg',
    slug: 'phu-quoc-island',
    date: '02.11.2024',
    readTime: '3.5',
  },
  {
    title: "מנהרות קוצ'י",
    description:
      'רשת מנהרות סודית באורך 250 ק"מ מתחת לאדמה – סיפור מרתק של גרילה, הישרדות ותושייה במלחמת וייטנאם',
    imageUrl: '/images/vietnam/cu-chi-tunnels/cu-chi-tunnels-preview.jpeg',
    slug: 'cu-chi-tunnels',
    date: '10.11.2024',
    readTime: '2.5',
  },
  {
    title: 'דלתת המקונג',
    description:
      'דלתת המקונג היא אזור טבע מרשים בוייטנאם שמציע חוויות טבע ותרבות מיוחדות.',
    imageUrl:
      '/images/vietnam/mekong-river-delta/mekong-river-delta-preview.jpeg',
    slug: 'mekong-river-delta',
    date: '18.11.2024',
    readTime: '3',
  },
  {
    title: "הו צ'י מין סיטי",
    description:
      'עיר תוססת ומרתקת המשלבת היסטוריה, גורדי שחקים, שווקים צבעוניים ואוכל רחוב מעולה – הלב הפועם של וייטנאם',
    imageUrl: '/images/vietnam/ho-chi-minh-city/ho-chi-minh-city-preview.jpeg',
    slug: 'ho-chi-minh-city',
    date: '26.11.2024',
    readTime: '4',
  },
  {
    title: 'פארק Ba Na Hills',
    description:
      'חוויה קסומה בגובה 1,500 מטר: רכבל מרהיב, גשר הידיים האיקוני, כפר צרפתי, מתקנים ומשחקים – כל זה בפארק Ba Na Hills המופלא שבהרי וייטנאם',
    imageUrl: '/images/vietnam/ba-na-hills-park/ba-na-hills-park-preview.jpeg',
    date: '10.03.2024',
    readTime: '10',
    slug: 'ba-na-hills-park',
  },
  {
    title: 'פו לונג',
    description:
      'שמורת טבע קסומה עם טרסות אורז, מפלים, שבטי הרים וחוויות אקולוגיות אותנטיות – מושלמת למי שמחפש טבע ושקט מחוץ למסלול התיירים',
    imageUrl: '/images/vietnam/pu-luong/pu-luong-preview.jpeg',
    slug: 'pu-luong',
    date: '05.12.2024',
    readTime: '3',
  },
  {
    title: "מאי צ'או",
    description:
      'אזור כפרי הררי ויפהפה בצפון וייטנאם, עם שדות אורז, כפרים מסורתיים, טיולי אופניים ומפגש מרגש עם תרבות שבט הטאי הלבן',
    imageUrl: '/images/vietnam/mai-chau/mai-chau-preview.jpeg',
    slug: 'mai-chau',
    date: '13.12.2024',
    readTime: '2.5',
  },
  {
    title: 'הכפר קאט קאט',
    description:
      'קאט קאט הוא כפר מסורתי סמוך לסאפה, המציע תרבות שבטית, מפלים ונוף מרהיב – חוויה אותנטית בצפון וייטנאם',
    imageUrl: '/images/vietnam/cat-cat-village/cat-cat-village-preview.jpeg',
    slug: 'cat-cat-village',
    date: '21.12.2024',
    readTime: '2',
  },
  {
    title: 'סאפה',
    description:
      'עיירה הררית קסומה בצפון וייטנאם, מוקפת טרסות אורז, שבטים מסורתיים ונופים עוצרי נשימה – יעד חובה לחובבי טבע ותרבות',
    imageUrl: '/images/vietnam/sa-pa/sa-pa-preview.jpeg',
    slug: 'sa-pa',
    date: '30.12.2024',
    readTime: '3',
  },
  {
    title: "הא ג'יאנג",
    description:
      'מחוז הררי פראי בצפון וייטנאם עם נופים דרמטיים, תרבות אתנית עשירה וטיול אופנועים בלופ בלתי נשכח – חוויה של טבע והרפתקה אמיתית',
    imageUrl: '/images/vietnam/ha-giang/ha-giang-preview.jpeg',
    slug: 'ha-giang',
    date: '07.01.2025',
    readTime: '3.5',
  },
  {
    title: 'הא לונג ביי',
    description:
      'נוף עוצר נשימה של איים גירניים, מערות מרהיבות, שייט רומנטי וכפרי דייגים – פלא טבעי שהוא חוויה בלתי נשכחת בצפון וייטנאם',
    imageUrl: '/images/vietnam/ha-long-bay/ha-long-bay-preview.jpeg',
    slug: 'ha-long-bay',
    date: '15.01.2025',
    readTime: '4',
  },
  {
    title: 'האנוי',
    description:
      'עיר ססגונית ומרתקת עם היסטוריה עשירה, שווקים צבעוניים, קפה ייחודי וסצנת אוכל רחוב מהטובות באסיה – חוויה אותנטית בלב וייטנאם',
    imageUrl: '/images/vietnam/hanoi/hanoi-preview.jpeg',
    slug: 'hanoi',
    date: '28.01.2025',
    readTime: '4',
  },
  {
    title: 'נין בין - טאם קוק',
    description:
      'טבע עוצר נשימה, שיט בין צוקים ומערות, תצפיות מרהיבות ואתרים היסטוריים – חוויה בלתי נשכחת בלב צפון וייטנאם',
    imageUrl: '/images/vietnam/ninh-binh/ninh-binh-preview.jpeg',
    slug: 'ninh-binh',
    date: '05.02.2025',
    readTime: '3',
  },
  {
    title: 'הוי אן',
    description:
      'עיר קסומה ומלאת היסטוריה, עם סמטאות ציוריות, פנסים זוהרים, נהר רומנטי וסצנה תרבותית ואמנותית מרתקת בלב וייטנאם',
    imageUrl: '/images/vietnam/hoi-an/hoi-an-preview.jpeg',
    slug: 'hoi-an',
    date: '14.02.2025',
    readTime: '3.5',
  },
  {
    title: 'פונג נה',
    description:
      'טבע פראי, מערות ענק, נהרות צלולים ונופים דרמטיים – חוויה בלתי נשכחת בלב הפארק הלאומי פונג נה שבמרכז וייטנאם',
    imageUrl: '/images/vietnam/phong-nha/phong-nha-preview.jpeg',
    slug: 'phong-nha',
    date: '22.02.2025',
    readTime: '3',
  },
].map((article) => ({
  ...article,
  articleLink: `/international/vietnam/destination/${article.slug}`,
  relatedArticlesSlugs:
    relatedArticlesSlugsMap[
      article.slug as keyof typeof relatedArticlesSlugsMap
    ],
}));
